import {useCallback, useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import '../../common/commonPayCs.css'
import {Button, Image, Toast} from "antd-mobile";
import {paySumbit} from "../../common/ApiAction";
import {TOASTDURATION} from "../../common/Utils";

const MtnAndMoovPay = () => {
    const navigate = useNavigate();
    const [paymentMethod, setPaymentMethod] = useState<string>("")
    const marchand = process.env.REACT_APP_ENV === 'production05' ? 'E-Go Sénégal' : process.env.REACT_APP_ENV === 'production03' ? 'E-Go Côte d\'Ivoire' : 'E-Go Sénégal';
    const [orderNo, setOrderNo] = useState<string>("")
    const [time, setTime] = useState<string>("")
    const [payAmount, setPayAmount] = useState<string>("")
    const [telephone, setTelephone] = useState<string>('')
    const [userName, setUserName] = useState<string>('')
    const [waveLaunchUrl, setWaveLaunchUrl] = useState<string>("")
    let location = useLocation();

    const sumbitAction = useCallback((payId: any, paymentMethodData: string) => {
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        paySumbit({payId}).then((res: any) => {
            Toast.clear();
            if (paymentMethodData === 'WAVE_API') {
                // if (parseInt(res.code) !== 200) {
                //     Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
                //     navigate(-1)
                // } else {
                //     setWaveLaunchUrl(res.data)
                // }
                if (!res.executed) {
                    Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
                    navigate(-1)
                } else {
                    setWaveLaunchUrl(res.data.wave_launch_url)
                }
            } else {
                if (!res.executed) {
                    Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
                    navigate(-1)
                } else {
                    if (paymentMethodData === 'WAVE_CI') {
                        setWaveLaunchUrl(res.data.data.payment_url)
                    } else {
                        Toast.show({icon: 'success', content: "Passer une commande avec succès", duration: TOASTDURATION})
                    }
                }
            }
        }).catch(err => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message ? err.message : 'Erreur de paiement', duration: TOASTDURATION, afterClose: () => navigate(-1)})
        })
    }, [navigate])

    useEffect(()=> {
        const data: any = location.state
        if (data) {
            setPaymentMethod(data.paymentMethod)
            setOrderNo(data.merchantTransactionId)
            setTime(data.createTime)
            setPayAmount(data.payAmount)
            setTelephone(data.telephone)
            if (data.id) {
                sumbitAction(data.id, data.paymentMethod)
            }
            if (data.userName) {
                setUserName(data.userName)
            }
        }
    },[location.state, sumbitAction])

    const openWaveMoney = () => {
        if (!waveLaunchUrl) {
            navigate(-1)
        }
        window.open(waveLaunchUrl, '_blank', 'noopener,noreferrer');
    }

    const _renderHeadItemUI = (name:string, data: string) => {
        if (data) {
            return <div style={{display: "flex", flexDirection: "row", alignItems: "center", flexWrap: "wrap", paddingLeft: 10, paddingRight: 20, marginTop: 5}}>
                <span style={{fontSize: 16, fontWeight: 500}}>{name}:</span>
                <span style={{color: '#ffb32b', paddingLeft: 5, fontSize: 15, fontWeight: 500}}>{data ? data : '---'}</span>
            </div>
        }
        return null
    }
    const _renderPromptUI = () => {
        if (paymentMethod === 'MOOV_CI') {
            return <div>
                <div className={'prompt-title'}>Suivez les étapes suivantes pour finaliser le paiement</div>
                <div className={'prompt-txt'}>1. Vérifiez votre numéro <span className={'prompt-spece'}>Moov Money</span> puis cliquez sur confirmer.</div>
                <div className={'prompt-txt'}>2. Confirmez le paiement en saisissant votre code secret Moov Money dans le menu qui s'ouvre sur votre téléphone. (Vous disposez de trois
(3) minutes pour répondre)</div>
            </div>
        } else if (paymentMethod === 'MTN_CI') {
            return <div>
                <div className={'prompt-title'}>Suivez les éfapes suivanfes pour finaliser le paiement</div>
                <div className={'prompt-txt'}>1. Vérifiez votre numéro <span className={'prompt-spece'}>MTN Mobile Money</span> puis cliquez sur confirmer.</div>
                <div className={'prompt-txt'}>2. Répondez au SMS qui yous est envoyé en composant *133# puisapprouvez la demande de paiement.(Vous disposez de frois(3)minutes pour répondre)</div>
                <div className={'prompt-txt'}>3. Confirmez le paiement en saisissant votre code secrel MTN MobileMoney</div>
            </div>
        }
        return null
    }
    const _renderSubmitUI = () => {
        return <div>
            <div className={'prompt-txt'}>NB : Votre code secret n'est pas communiqué à <span className={'prompt-spece'}>{marchand}</span></div>
            <div style={{border: "solid black 1px", borderRadius: 4, display: "flex", flexDirection: "row", alignItems: "center", padding: '10px 0', marginTop: 10}}>
                <span style={{flex: 4, textAlign: "center", borderRight: 'solid black 1px'}}>Votre numéro</span>
                <span style={{flex: 5, paddingLeft: 25}}>{telephone}</span>
            </div>
        </div>
    }
    return (
        <div style={{width: '100%', backgroundColor: '#FFF'}}>
            <div style={{width: '100%', backgroundColor: '#efefef', paddingBottom: 20, paddingTop: 35}}>
                {_renderHeadItemUI('Marchand', marchand)}
                {_renderHeadItemUI('Numéro de commande', orderNo)}
                {_renderHeadItemUI('Date', time)}
                {_renderHeadItemUI('Montant (FCFA)', payAmount)}
                {_renderHeadItemUI('Nom et prénom', userName)}
            </div>
            <div style={{paddingLeft: 25, paddingRight: 25, marginTop: 20}}>
                {_renderPromptUI()}
                {_renderSubmitUI()}
                <div style={{marginTop: 10}}>
                    <Button
                        onClick={() => openWaveMoney()}
                        style={{color: '#FFF', backgroundColor: '#fdc619', width: '100%', fontWeight: 600}}>Confirmer</Button>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                <Image src={require('../../assets/icon_ego_logo.jpg')} style={{width: 100}}/>
            </div>
        </div>
    )
}
export default  MtnAndMoovPay
